module.exports = __webpack_public_path__ + "static/media/transfer.05a833c8.jpg";